import { render, staticRenderFns } from "./transferplan.vue?vue&type=template&id=8b6f79b2"
import script from "./transferplan.vue?vue&type=script&lang=js"
export * from "./transferplan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports